import { PageLocatorMap } from '../types/PageLocatorMap';

export const signUpPinVerifyPage = {
  alert: {
    error: 'signup-pin-verify.alert.error',
    success: 'signup-pin-verify.alert.success',
  },
  footer: {
    root: 'signup-pin-verify.footer',
  },
  form: {
    h1: 'signup-pin-verify.form.heading1',
    h3: 'signup-pin-verify.form.heading3',
    pinInput1: 'signup-pin-verify.form.pin-input-1',
    pinInput2: 'signup-pin-verify.form.pin-input-2',
    pinInput3: 'signup-pin-verify.form.pin-input-3',
    pinInput4: 'signup-pin-verify.form.pin-input-4',
    pinInput5: 'signup-pin-verify.form.pin-input-5',
    pinInput6: 'signup-pin-verify.form.pin-input-6',
    pinInputError: 'signup-pin-verify.form.pin-error',
    resendPinLink: 'signup-pin-verify.form.resend-pin-link',
    root: 'signup-pin-verify.form.root',
  },
  header: {
    root: 'signup-pin-verify.header',
    signUpLink: 'signup-pin-verify.header.signup-link',
  },
} as const satisfies PageLocatorMap;
